<template>
  <div class="card" v-bind:class="{opened: isCardOpened}" v-if="question !== undefined">
    <div>
      
      <div class="timer" v-bind:class="{timeIsRunning: isTimerRunning}">
        <div>
          <svg class="svg-timer" viewBox="0 0 87.46 114.15"><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><path class="cls-1" d="M39.63,27.29c-4.1,0-7.6-.27-9.91-2.56-1.51-1.5-2.25-3.61-2.25-6.47a16.26,16.26,0,0,1,32.52,0c0,2.86-.74,5-2.25,6.47-2.67,2.64-7,2.6-11.89,2.55-1.38,0-2.86,0-4.24,0Zm4.1-4,2.16,0c4,0,7.55.08,9-1.39A5,5,0,0,0,56,18.26a12.26,12.26,0,0,0-24.52,0,5,5,0,0,0,1.07,3.63c1.48,1.47,5,1.43,9,1.39Z"/><path class="cls-2" d="M43.73,2A16.27,16.27,0,0,1,60,18.26c0,2.86-.74,5-2.25,6.47-2.31,2.29-5.83,2.56-9.94,2.56H39.63c-4.1,0-7.6-.27-9.91-2.56-1.51-1.5-2.25-3.61-2.25-6.47A16.28,16.28,0,0,1,43.73,2M39.65,23.29h1.92l2.16,0,2.16,0h1.92c3.21,0,5.87-.17,7.11-1.4A5,5,0,0,0,56,18.26a12.26,12.26,0,0,0-24.52,0,5,5,0,0,0,1.07,3.63c1.24,1.23,3.9,1.4,7.11,1.4M43.73,0A18.28,18.28,0,0,0,25.47,18.26c0,3.42.93,6,2.85,7.89,2.92,2.9,7.19,3.14,11.31,3.14H47.8c4.14,0,8.42-.24,11.34-3.13,1.92-1.9,2.85-4.48,2.85-7.9A18.28,18.28,0,0,0,43.73,0ZM39.65,21.29c-1.33,0-4.87,0-5.71-.82-.11-.11-.47-.59-.47-2.21a10.26,10.26,0,0,1,20.52,0c0,1.62-.36,2.1-.47,2.21-.84.82-4.38.82-5.71.82H45.72l-2,0-2,0h-2.1Z"/><path class="cls-3" d="M39.65,25.79c-3.77,0-7-.24-8.87-2.12-1.22-1.21-1.81-3-1.81-5.41a14.76,14.76,0,0,1,29.52,0c0,2.43-.59,4.2-1.81,5.41-2.22,2.2-6.2,2.16-10.81,2.11-1.4,0-2.88,0-4.28,0Zm4.08-1,2.15,0c4.39,0,8.17.08,10.1-1.82a6.37,6.37,0,0,0,1.51-4.7,13.76,13.76,0,0,0-27.52,0A6.37,6.37,0,0,0,31.48,23c1.93,1.9,5.72,1.86,10.1,1.82Z"/><circle class="cls-1" cx="43.73" cy="26.99" r="7.45"/><circle class="cls-3" cx="42.87" cy="26.18" r="4.92"/><path class="cls-2" d="M43.73,35.94a9,9,0,1,1,9-8.95A9,9,0,0,1,43.73,35.94Zm0-14.91a6,6,0,1,0,6,6A6,6,0,0,0,43.73,21Z"/><circle class="cls-1" cx="43.73" cy="70.42" r="40.23"/><circle class="cls-3" cx="42.77" cy="69.08" r="32.5"/><circle class="cls-4" cx="43.73" cy="70.42" r="28.45"/><path class="cls-2" d="M43.73,100.37a30,30,0,1,1,30-29.95A30,30,0,0,1,43.73,100.37Zm0-56.9a27,27,0,1,0,27,27A27,27,0,0,0,43.73,43.47Z"/><path class="cls-2" d="M43.73,114.15A43.73,43.73,0,1,1,87.46,70.42,43.78,43.78,0,0,1,43.73,114.15Zm0-80.46A36.73,36.73,0,1,0,80.46,70.42,36.78,36.78,0,0,0,43.73,33.69Z"/><path class="cls-2" d="M55.65,58.52a2,2,0,0,1,0-2.82l3-3a2,2,0,0,1,2.82,2.83l-3,3A2,2,0,0,1,55.65,58.52Z"/><path class="cls-2" d="M60.58,70.42a2,2,0,0,1,2-2h4.18a2,2,0,0,1,0,4H62.58A2,2,0,0,1,60.58,70.42Z"/><path class="cls-2" d="M55.65,82.32a2,2,0,0,1,2.83,0l3,3a2,2,0,1,1-2.82,2.83l-3-3A2,2,0,0,1,55.65,82.32Z"/><path class="cls-2" d="M43.76,87.24a2,2,0,0,1,2,2v4.18a2,2,0,0,1-4,0V89.24A2,2,0,0,1,43.76,87.24Z"/><path class="cls-2" d="M31.86,82.32a2,2,0,0,1,0,2.82l-2.95,3a2,2,0,1,1-2.83-2.83l3-3A2,2,0,0,1,31.86,82.32Z"/><path class="cls-2" d="M26.93,70.42a2,2,0,0,1-2,2H20.76a2,2,0,0,1,0-4h4.17A2,2,0,0,1,26.93,70.42Z"/><path class="cls-2" d="M31.86,58.52a2,2,0,0,1-2.83,0l-3-3a2,2,0,1,1,2.83-2.83l2.95,3A2,2,0,0,1,31.86,58.52Z"/><path class="cls-2" d="M43.76,53.6a2,2,0,0,1-2-2V47.42a2,2,0,0,1,4,0V51.6A2,2,0,0,1,43.76,53.6Z"/><path id="SECONDS" class="cls-2" d="M43.73,77.44a2,2,0,0,1-2-2v-18a2,2,0,0,1,4,0v18A2,2,0,0,1,43.73,77.44Z"/><circle class="cls-2" cx="43.73" cy="70.42" r="3.96"/><circle class="cls-1" cx="43.73" cy="70.42" r="2.58"/><circle class="cls-3" cx="43.32" cy="70.01" r="2"/></g></g></svg>
        </div>
      </div>
      <h3>{{_question.lang[lang].question}}</h3>
      <ul>
        <li v-for="(q,a) in _question.lang[lang]" v-if="a != 'question'" :key="a" v-on:click="answer = a" v-bind:class="{correct: (_correct == a && typeof answer !== 'undefined'), incorrect: (_correct != a && answer == a)}">{{q}}</li>
      </ul>
    </div>
    <div class="question-overlay" v-if="displayCorrectOverlay">
      <div><SvgIcon width="50vw" icon="thumbUp" /></div>
    </div>
    
    <div class="question-overlay incorrect" v-if="displayIncorrectOverlay">
      <div>
        <SvgIcon width="30vw" icon="meh" />
        <h4>{{ $t('question.oups') }}</h4>
        <p>{{ $t('question.no', { a: _correct.toUpperCase(), text: _correctText}) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Question',
  
  props: {
   question: Object,
   lang: {type: String, default: "fr" }
  },

  data() {
    return {
      answer: undefined,
      isCardOpened: false,
      displayCorrectOverlay:false,
      displayIncorrectOverlay:false,
      isTimerRunning: false,
      timerStartTime: undefined,
      pointsWon : 0,
    }
  },

  computed: {
    _question: function(){
      if(typeof this.question !== "undefined" ){ return this.question }
      else{ return {question:"", correct:"a", lang:{fr:{a:"",b:"",c:"",d:""}}} }
    },
    _correct: function(){
      return this._question.correct;
    },
    
    _correctText: function(){
      return this._question.lang[this.lang][ this._correct ];
    }
  },

  watch: {
    answer: function(val){
      
      this.displayCorrectOverlay   = ( this._correct == this.answer )
      this.displayIncorrectOverlay = ( this._correct != this.answer && typeof val !== "undefined" );
      if( typeof val !== "undefined" ){
        var seconds = this.stopTimer();
        this.pointsWon = this.getPoints(seconds);
        window.setTimeout(this.hideCard, (this.displayCorrectOverlay ? 3000 : 5000));
        this.$emit("questionAnswered", this.pointsWon, this.question);
      }
    },

    question: function(val){
      this.isCardOpened = true;
      this.answer = undefined;
      this.pointsWon = 0;
      this.displayCorrectOverlay = false;
      this.displayIncorrectOverlay = false;
    },

    isCardOpened: function(val){
      if( val ){ 
        this.$emit('openStart');
        window.setTimeout(this.startTimer, 2500);
      }
      else{ this.$emit('closeStart'); }
    }
  },

  methods: {
    hideCard: function(){
      this.isCardOpened = false;
      window.setTimeout(() => {this.$emit("questionDisapeared", this.question)}, 1000);
    },

    startTimer: function(){
      this.isTimerRunning = true;
      this.timerStartTime = new Date().getTime();
    },
    
    stopTimer: function(){
      this.isTimerRunning = false;
      var seconds = Math.abs( (new Date().getTime() - this.timerStartTime)/1000 );
      return ( isNaN(seconds) ? 0 : seconds );
    },

    getPoints: function(_s){
      if( this.displayCorrectOverlay && _s < 15 ){ return Math.ceil( (15-_s)*100 ); }
      if( this.displayCorrectOverlay ){ return 100; }
      return 0;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Question.vue